
      function loadMathJax() {
        if (window.mathJaxLoaded) return;
        window.mathJaxLoaded = true;

        var script = document.createElement('script');
        var isEmbed =
          window.location?.pathname?.indexOf('embed') > -1 && window.location.search.length == 0;

        if (import.meta.env.VITE_REGION === 'china') {
          script.src = '/mathjax/es5/tex-svg-full.min.js';
        } else if (isEmbed) {
          // Pamoja/MB - we want mathjax to render latex and mathml for font parity - only in embed
          script.src =
            'https://cdnjs.cloudflare.com/ajax/libs/mathjax/3.1.2/es5/tex-mml-svg.min.js';
          script.integrity =
            'sha512-cvY8FLZ100SA0lUHyX38BDEr1rz0AKP6Iz+t5yfOPOyuKX72RNHIuPGH/+ScEsbKBhngYhKJSaFbtKet0te1Sw==';
          script.crossOrigin = 'anonymous';
          script.referrerPolicy = 'no-referrer';
        } else {
          // AP and OSC - we want mathjax to render latex and wiris to render mathml. Also is used for QB author even if pamoja so authors might think different font
          script.src =
            'https://cdnjs.cloudflare.com/ajax/libs/mathjax/3.1.2/es5/tex-svg-full.min.js';
          script.integrity =
            'sha512-QrJlCHKrgI59L3L/iOlwyEfg4uY7KdiIdZEXaHX9BIgkSsP+9wmPN+rM4/yJbdS/KHB7EFFvhV75TYAJgaPqUw==';
          script.crossOrigin = 'anonymous';
          script.referrerPolicy = 'no-referrer';
        }
        script.async = true;
        document.body.appendChild(script);
      }

      // Load MathJax when user interacts or after delay
      const mathJaxTriggers = ['click', 'scroll', 'touchstart', 'keydown'];
      const loadMathJaxOnce = () => {
        loadMathJax();
        mathJaxTriggers.forEach((event) =>
          document.removeEventListener(event, loadMathJaxOnce, { passive: true })
        );
      };

      mathJaxTriggers.forEach((event) =>
        document.addEventListener(event, loadMathJaxOnce, { passive: true })
      );

      // Fallback: load after 3 seconds if no interaction
      setTimeout(loadMathJax, 3000);
    